import 'css/src/global';

import React from 'react';

import DashboardTrim from 'js/src/components/common/DashboardTrim';
import FeatureLockModal from 'js/src/components/common/ui/feature-lock-modal';
import ShareVideo from 'js/src/components/share-video/share-video';
import { LUMINARY_VIDEO_STORE_NAME, LuminaryContextProvider } from 'js/src/luminary';

const ShareVideoPage = React.memo(function ShareVideoPage() {
    return (
        <LuminaryContextProvider
            minDimensionResolution={window.screen && window.screen.availWidth <= 900 ? 300 : 500}
            drawsToCanvas={true}
            name={LUMINARY_VIDEO_STORE_NAME}
        >
            <DashboardTrim sidebar="none">
                <ShareVideo />
            </DashboardTrim>
            <FeatureLockModal key="feature_lock_modal" />
        </LuminaryContextProvider>
    );
});

export default ShareVideoPage;
